import { render, staticRenderFns } from "./ActionsWidget.vue?vue&type=template&id=1924deea&scoped=true&"
import script from "./ActionsWidget.vue?vue&type=script&lang=js&"
export * from "./ActionsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ActionsWidget.vue?vue&type=style&index=0&id=1924deea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1924deea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/architect/projects/gadzoom/gadzoom-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1924deea')) {
      api.createRecord('1924deea', component.options)
    } else {
      api.reload('1924deea', component.options)
    }
    module.hot.accept("./ActionsWidget.vue?vue&type=template&id=1924deea&scoped=true&", function () {
      api.rerender('1924deea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pricing/ActionsWidget.vue"
export default component.exports